import { Link } from "react-router-dom";

export function NotFoundPage() {
  return <section className="auth-gate">
    <p className="eyebrow">PAGE NOT FOUND</p>
    <h1>This path has gone quiet.</h1>
    <p>Return to the Five-Tone listening room and begin again.</p>
    <Link className="button primary" to="/">Back to home</Link>
  </section>;
}
